module.exports = __webpack_public_path__ + "6e10358911af27bb640f4c1fc66fb600.png";